module.exports = __webpack_public_path__ + "img/edge_divers_commerce.dd523328.svg";